<template>
  <!-- Modal -->
  <div
    class="modal fade"
    :id="modal_id"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <slot name="modalTitle">工程を追加</slot>
          </h5>
        </div>
        <div class="modal-body">
          <div class="row g-3">
            <div class="col-12">
              <label for="create_inspection_type_name" class="form-label"
                >工程名</label
              >
              <input
                v-model="inspection_type.name"
                type="text"
                class="form-control"
                :class="{
                  'is-invalid': v$.inspection_type.name.$error,
                }"
                id="create_inspection_type_name"
              />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            閉じる
          </button>
          <button
            type="button"
            class="btn btn-dark"
            v-on:click.prevent="insert()"
          >
            <slot name="submitButton">保存</slot>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import inspectionStore from '@/apps/inspection/manage/store'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { Modal } from 'bootstrap/dist/js/bootstrap.esm.min.js'

export default {
  name: 'InspectionTypeCreateForm',
  components: {},

  setup() {
    return { v$: useVuelidate() }
  },

  emits: ['insertType'],

  data() {
    return {
      modal: null,
      inspection_type: {},
    }
  },
  computed: {
    modal_id: function () {
      let chars = 'abcdefghijklmnopqrstuvwxyz0123456789'
      let rand_str = ''
      for (let i = 0; i < 8; i++) {
        rand_str += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      return 'form-modal-' + rand_str
    },
  },
  validations() {
    return {
      inspection_type: {
        name: { required },
      },
    }
  },

  mounted() {
    this.modal = new Modal(document.getElementById(this.modal_id))
    document
      .getElementById(this.modal_id)
      .addEventListener('hidden.bs.modal', this.cleanForm)
  },
  beforeUnmount() {
    this.modal.hide()
  },

  methods: {
    show() {
      this.modal.show()
    },
    async insert() {
      const result = await this.v$.$validate()
      if (!result) {
        return
      }
      const data = await inspectionStore.dispatch(
        'inspection_type/postData',
        this.inspection_type,
      )
      this.$emit('insertType', data)
      this.modal.hide()
    },
    cleanForm() {
      this.v$.$reset()
      this.inspection_type = {}
    },
  },
}
</script>
